import React, { useEffect, useState } from 'react';
import { Image, Space, Table } from 'antd';
import { useWebsiteStattistic } from '.';

const getProductImageUrl = (record) => {
  const image = record?.variant?.image
    || record?.variant?.images?.[0]
    || record?.product?.thumbnail
    || record?.product?.image
    || record?.product?.images?.[0]
    || null;

  if (!image) return null;
  if (typeof image === 'string') return image;
  return image?.url || null;
};

const columns = [
  {
    title: 'Tên',

    render: (_, record) => {
      const imageUrl = getProductImageUrl(record);

      return (
        <>
          <Space size={8}>
            {imageUrl && (
              <Image
                src={imageUrl}
                width={32}
                height={32}
                style={{ objectFit: 'cover', borderRadius: 6 }}
                fallback='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiI+PHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSIjZjVmNWY1Ii8+PC9zdmc+'
              />
            )}
            <span>
              {record.product?.name} {record.variant?.variant_title}
            </span>
          </Space>
        </>
      )
    },
  },
  {
    title: 'Số lượng',
    render: (_, record) => {
      return (
        <>
          {record.quantity}
        </>
      )
    },
  },



];

const Products = () => {
  const { data } = useWebsiteStattistic();
  const [topProduct, setTopProduct] = useState([])
  useEffect(() => {
    if (data.top_product_incart) {
      setTopProduct(data.top_product_incart);
    } else {
      setTopProduct([])
    }
  }, [data.top_product_incart])



  return (
    <Table columns={columns} dataSource={topProduct} rowKey={(record, index) => `${record?.variant?.variant_id || record?.product?.id || 'item'}-${index}`} />
  )
};
export default Products;